import {
  AppRouteService,
} from 'webcommon/legacy-common';

export function AppRouteServiceFactory(i: angular.auto.IInjectorService) {
  return i.get<AppRouteService>('AppRoutes');
}

export const AppRoutesAjsProvider = {
  deps: ['$injector'],
  provide: AppRouteService,
  useFactory: AppRouteServiceFactory,
};
